// Marketing / Business / Design
import ADARENA from "./assets/ADARENA.jpeg";
import CASECATALYST from "./assets/CASECATALYST.png";
import FOLDANDBUILD from "./assets/FOLDANDBUILD.png";
import LOGOHUNT from "./assets/LOGOHUNT.jpeg";

// AI / Quiz / Puzzle
import AIHUNTING from "./assets/AIHUNTING.jpeg";
import AIPROMPTBATTLE from "./assets/AIPROMPTBATTLE.png";
import AIQUIZ from "./assets/AIQUIZ.jpeg";
import AISSHAPECIPHER from "./assets/AISSHAPECIPHER.png";
import PUZZLEHUNT from "./assets/PUZZLEHUNT.png";
import ESCAPEROOM from "./assets/ESCAPEROOM.png";

// Coding / Tech
import BLINDCODE from "./assets/BLINDCODE.jpeg";
import BREAKTHEBOT from "./assets/BREAKTHEBOT.png";
import REVERSEDCODING from "./assets/REVERSECODING.png";
import QUANTUMQUEST from "./assets/QUANTUMQUESTPHYSICS.jpeg";

// Gaming / Fun
import BGMI from "./assets/BGMI.jpeg";
import FREEFIREPRO from "./assets/FREEFIREPRO.png";
import LUDOKING from "./assets/LUDOKING.jpeg";
import SPINMANIA from "./assets/SPIN-MANIA.jpeg";
import MYSTICMOVER from "./assets/MYSTICMOVER.jpeg";

// Robotics
import DRONEDASH from "./assets/DRONEDASH.jpeg";
import ROBOWAR from "./assets/ROBOWARPRO.png";
import ROBORUSH from "./assets/ROBORUSH.jpeg";
import ROBOFOOTBALL from "./assets/ROBOFOOTBALLCLASH.jpeg";

// Other
import BIZBRAIN from "./assets/BIZBRAINCHALLENGE.png";
import BRAINBOOSTER from "./assets/BRAINBOOSTERMATH.jpeg";
import BRIDGEBATTLE from "./assets/BRIDGEBATTLE.jpeg";
import BULLVSBEAR from "./assets/BULLVSBEAR.jpeg";
import CRICKETCARNIVAL from "./assets/CRICKETCARNIVAL.jpeg";
import DREAMTODEAL from "./assets/DREAMTODEAL.png";
import TREASUREHUNT from "./assets/TREASUREHUNT.jpeg";
import SQUIDGAME from "./assets/SQUIDGAMEINTECHWORLD.jpeg"
import AUTONOMOUSROBOTICS from "./assets/autonomous-robotics-workshop.png";
import ROBOTICSCHALLENGE from "./assets/robotics-challenge.png";

// Additional Imports
import REALLIFEAMONGUS from "./assets/REALLIFEAMONGUS.jpeg";
import WEBTREASUREHUNTING from "./assets/WEB-TREASURE-HUNTING.png";
import MINIMUSTIFOR1MIN from "./assets/MINIMUSTIFOR1MIN.png";
import ROBOMINDMATRIX from "./assets/ROBOMINDMATRIX.png";
import SURVIVORDROP from "./assets/SURVIOURDROP.png";
import THECHEMICALDETECTIVE from "./assets/THECHEMICALDETECTIVE.png";
import WORDWIZARDENGLISH from "./assets/WORDWIZARDENGLISH.jpeg";

export const EVENT_IMAGES = {
  "adrena": ADARENA, // Fixed spelling from adarena
  "ai-hunting": AIHUNTING,
  "ai-prompt-battle": AIPROMPTBATTLE,
  "ai-quiz": AIQUIZ,
  "ai-shape-cipher": AISSHAPECIPHER,
  "bgmi": BGMI,
  "biz-brain-challenge": BIZBRAIN,
  "blind-code": BLINDCODE,
  "brain-booster-math": BRAINBOOSTER,
  "break-the-bot": BREAKTHEBOT,
  "bridge-battle": BRIDGEBATTLE,
  "bull-vs-bear": BULLVSBEAR,
  "case-catalyst": CASECATALYST,
  "cricket-carnival": CRICKETCARNIVAL,
  "dream-to-deal": DREAMTODEAL,
  "drone-dash": DRONEDASH,
  "escape-room": ESCAPEROOM,
  "fold-and-build": FOLDANDBUILD,
  "free-fire-pro": FREEFIREPRO,
  "logo-hunt": LOGOHUNT,
  "ludo-king": LUDOKING,
  "mini-musti-for-1-min": MINIMUSTIFOR1MIN, // NEW
  "mystic-mover": MYSTICMOVER,
  "puzzle-hunt": PUZZLEHUNT,
  "quantum-quest-physics": QUANTUMQUEST,
  "real-life-among-us": REALLIFEAMONGUS, // NEW
  "reverse-coding": REVERSEDCODING,
  "robo-football-clash": ROBOFOOTBALL, // Fixed key
  "robo-mind-matrix": ROBOMINDMATRIX, // NEW
  "robo-rush": ROBORUSH,
  "robo-war-pro": ROBOWAR, // Fixed key
  "autonomous-robotics-workshop": AUTONOMOUSROBOTICS,
  "robotics-challenge": ROBOTICSCHALLENGE,
  "spin-mania": SPINMANIA,
  "survivor-drop": SURVIVORDROP, // NEW
  "the-chemical-detective": THECHEMICALDETECTIVE, // NEW
  "treasure-hunt": TREASUREHUNT,
  "web-treasure-hunting": WEBTREASUREHUNTING, // NEW
  "word-wizard-english": WORDWIZARDENGLISH, // NEW
  "squid-game": SQUIDGAME,
  "DEFAULT": require("./assets/poster.jpg") // Fallback image
};